import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { PageLoaderService } from '../../shared/components/loader/page-loader.service';

@Component({
  selector: 'ls-cirrus-showcase',
  templateUrl: './cirrus-showcase.component.html',
  styleUrls: ['./cirrus-showcase.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CirrusShowcaseComponent implements AfterContentInit {
  public form: FormGroup = this.formBuilder.group({
    name: ['', [Validators.required]],
    lastName: ['Ostir', Validators.minLength(3)],
    simple1: [],
    simple2: [],
    simple3: [],
    simple4: [],
    simple5: [],
    simple6: [],
    simple7: ['Simple text', [Validators.required, Validators.minLength(12)]],
    simple8: [{ value: 'Disabled', disabled: true }],
    simple9: []
  });

  constructor(
    private formBuilder: FormBuilder,
    private pageLoaderService: PageLoaderService
  ) {
    this.pageLoaderService.setLoaded();
  }

  public ngAfterContentInit(): void {
    this.pageLoaderService.setLoaded();
  }
}
